import React, { useEffect } from 'react'
import { IoMdCheckmarkCircleOutline } from 'react-icons/io'
import { Button } from '../../Common/ui/button'
import '../../Styles/StartJourney.css'
import useCustomNavigate from '../../Common/ui/Navigate'
import * as RoutePaths from '../../Entities/RoutePath'
import { } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useGovernanceStore } from 'src/Containers/Onboarding/Store/GovernanceStore'

const StartJourney = () => {
    const { t } = useTranslation()
    const customNavigate = useCustomNavigate()

    const isCompleted = JSON.parse(localStorage.getItem('isCompleted'))
    const isAdmin = JSON.parse(localStorage.getItem('isAdmin'))
    const userRoles = JSON.parse(localStorage.getItem('userRoles'))
    const handleNavigatePage = () => {
        customNavigate(RoutePaths.ONBOARDING.URI + '?bodyType=1', RoutePaths.ONBOARDING.NAME)
        return true
        // eslint-disable-next-line no-unreachable
        if (isAdmin && isCompleted) {
            customNavigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.GOVERNANCE.ORG_CHART)
        } else if (isAdmin && !isCompleted) {
            customNavigate(RoutePaths.ONBOARDING.URI + '?bodyType=1', RoutePaths.ONBOARDING.NAME)
        } else {
            if (!isAdmin) {
                customNavigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.DASHBOARD.URI + (Object.keys(userRoles)?.find(ele => userRoles[ele]?.split(' ')?.[0]?.includes('Risk'))
                    ? RoutePaths.DASHBOARD.RISK
                    : RoutePaths.DASHBOARD.COMPLIANCE))
            } else {
                customNavigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.GOVERNANCE.ORG_CHART)
            }
        }
    }
    const { featNavigationData } = useGovernanceStore()
    useEffect(() => {
        if (featNavigationData.length > 0) {
            localStorage.setItem('featureNavigation', JSON.stringify(featNavigationData))
        }
    }, [featNavigationData])
    return (
        <div className="flex flex-col h-screen items-center w-full ">
            <div className='w-[74%] h-[95%] flex flex-col overflow-auto justify-center gap-[6%]'>
                <div className='flex justify-between'>
                    <div className='flex justify-start flex-col gap-20'>
                        <h1 className="journey-welcome-title text-h1 mb-4">{t('Welcome to')}</h1>
                        <div className='flex'>
                            <img loading="lazy" className='w-[50%]' src={'/Assets/CtdFullLogo.svg'} alt='nav-logo' />
                        </div>
                        <p className="journey-grc-title text-left">{t('Empowering Your Governance, Risk, and Compliance Journey')}</p>
                    </div>
                    <img src={'/Assets/WelcomeJourneyIcon.svg'} alt="Welcome" className='mb-10 w-[30%] max-w-[280px]' />
                </div>
                <div className="flex flex-wrap justify-center">
                    <div className="sm:w-1/3 mb-16 flex ">
                        <div className='journey-checkmark-container mr-2'>
                            <IoMdCheckmarkCircleOutline className="journey-checkmark-icon" />
                        </div>
                        <div className="text-center journey-category-title  text-b2 my-auto">{t('Unlock Insights')}</div>
                    </div>
                    <div className="sm:w-1/3 pb-16 flex ">
                        <div className='journey-checkmark-container mr-2'>
                            <IoMdCheckmarkCircleOutline className="journey-checkmark-icon" />
                        </div>
                        <div className="text-center journey-category-title  text-b2 my-auto">{t('Enhance Collaboration')}</div>
                    </div>
                    <div className="sm:w-1/3 pb-16 flex ">
                        <div className='journey-checkmark-container mr-2'>
                            <IoMdCheckmarkCircleOutline className="journey-checkmark-icon" />
                        </div>
                        <div className="text-center journey-category-title  text-b2 my-auto">{t('Innovate with Confidence')}</div>
                    </div>
                    <div className="sm:w-1/3 flex ">
                        <div className='journey-checkmark-container mr-2'>
                            <IoMdCheckmarkCircleOutline className="journey-checkmark-icon" />
                        </div>
                        <div className="text-center journey-category-title  text-b2 my-auto">{t('Streamline Processes')}</div>
                    </div>
                    <div className="sm:w-1/3 flex ">
                        <div className='journey-checkmark-container mr-2'>
                            <IoMdCheckmarkCircleOutline className="journey-checkmark-icon" />
                        </div>
                        <div className="text-center journey-category-title  text-b2 my-auto">{t('Stay Compliant')}</div>
                    </div>
                    <div className="sm:w-1/3 flex ">
                        <div className='journey-checkmark-container mr-2'>
                            <IoMdCheckmarkCircleOutline className="journey-checkmark-icon" />
                        </div>
                        <div className="text-center journey-category-title  text-b2 my-auto">{t('Experience Excellence')}</div>
                    </div>
                </div>
                <div className='flex justify-between items-center gap-3'>
                    <div className="text-left py-3">
                        <p className='journey-footer-para text-b2 leading-8 text-primary'>{t('Thank you for choosing CitadelVue as your trusted partner in GRC excellence.')}</p>
                        <p className='journey-footer-para text-b2 text-primary '> {t('Welcome aboard - let')}&apos;{t('s embark on this transformative journey together.')}</p>
                    </div>
                    <Button style={{ height: '40px', flexShrink: 0 }} className='p-20 get-started-button text-button' onClick={() => handleNavigatePage()}>
                        {t('Get Started')}
                        <img src={'/Common/Icon/StartArrow.svg'} alt="Welcome" className='w-[15px] ml-[15px]' />
                    </Button>
                </div>
            </div>
            <div className='flex-grow w-full' style={{ background: 'hsl(var(--primary))' }}>
            </div>
        </div>
    )
}

export default StartJourney
